import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Intro from '../components/intro/Intro';
import { connect } from 'react-redux';
import { getTutorialStatus } from './../actions/init';

import bgImage from './../globals/images/intro-bg.png';
import bgImageDark from './../globals/images/intro-bg-mask.png';
import gif1 from './../globals/images/attend.gif';
import gif2 from './../globals/images/accept.gif';
import gif3 from './../globals/images/Timer.gif';
import intro1 from './../globals/images/intro1.png';
import intro2 from './../globals/images/intro2.png';
import intro3 from './../globals/images/intro3.png';
import nextButton from '../globals/images/next-button.svg';
import gif4 from '../globals/images/eco-gif.gif';
import gif5 from '../globals/images/b2b-gif.gif';
import graph from '../globals/images/company-graph.png';
import orgChart from '../globals/images/orgChart.png';
import zoom from '../globals/images/zoom.svg';
import close from '../globals/images/close.svg';
import hover from '../globals/images/hover.svg';
import alert from '../globals/images/alert.svg';

class IntroContainer extends Component {

    componentDidMount = () => {
        getTutorialStatus();
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.tutorial.tutorialStatus !== -1) {
            if (nextProps.match.url === '/') {
                switch (nextProps.tutorial.tutorialStatus) {
                    case 1: window.location.href = window.location.href + 'tutorial-end'; break;
                    case 2: window.location.href = window.location.href + 'mails'; break;
                    default: return
                }
            }
        }
    }

    renderPreviousButton = () => {
        let { match } = this.props;
        switch (match.url) {
            case '/':
            case '/welcome':
            case '/intro': return false;
            default: return true;
        }
    }

    renderNextButton = () => {
        let { match } = this.props;
        switch (match.url) {
            case '/':
            case '/welcome':
            case '/intro-tutorial': return false;
            default: return true;
        }
    }

    getPrevUrl = () => {
        const { match } = this.props;
        switch (match.url) {
            case '/intro/company': return '/intro';
            case '/intro/character': return '/intro/company';
            case '/intro/objectives': return '/intro/character';
            case '/intro-tutorial': return '/intro/objectives';
            default: return '/';
        }
    }

    getNextUrl = () => {
        const { match } = this.props;
        switch (match.url) {
            case '/':
            case '/welcome': return '/intro';
            case '/intro': return '/intro/company';
            case '/intro/company': return '/intro/character';
            case '/intro/character': return '/intro/objectives';
            case '/intro/objectives': return '/intro-tutorial';
            default: return '/';
        }
    }

    getCurrentPageIdForStepper = () => {
        const { match } = this.props;
        switch (match.url) {
            case '/intro/company': return 0;
            case '/intro/character': return 1;
            case '/intro/objectives': return 2;
            default: return 0;
        }
    }

    render() {
        const welcomeStyle = {
            width: '100%',
            boxSizing: 'border-box',
            height: '100%',
            position: 'relative',

        };

        return (
            < div style={welcomeStyle} >
                <Intro
                    {...this.props}
                    renderPreviousButton={this.renderPreviousButton()}
                    renderNextButton={this.renderNextButton()}
                    prevUrl={this.getPrevUrl()}
                    nextUrl={this.getNextUrl()}
                    currentPageId={this.getCurrentPageIdForStepper()}
                    logoutType={this.props.uiState.user.logoutType}
                    introductionData={this.props.uiState.introductionData}
                />
                <div style={{ display: 'none' }}>
                    <img src={gif1} />
                    <img src={gif2} />
                    <img src={gif3} />
                    <img src={bgImage} />
                    <img src={bgImageDark} />
                    <img src={intro1} />
                    <img src={intro2} />
                    <img src={intro3} />
                    <img src={nextButton} />
                    <img src={gif4} />
                    <img src={gif5} />
                    <img src={graph} />
                    <img src={orgChart} />
                    <img src={zoom} />
                    <img src={close} />
                    <img src={alert} />
                    <img src={hover} />
                </div>
            </div >
        )
    }
}

const mapStatetoProps = (state) => {
    return state;
};

export default connect(mapStatetoProps)(IntroContainer);



// WEBPACK FOOTER //
// /src/containers/IntroContainer.js